import React from 'react';
import classNames from 'classnames';
import styles from './Toast.scss.js';
import Icon from '../../../../Icons/Icons/Icon/Icon.js';

const toastTypeClassName = {
  Dark: styles['wrapper__background--dark-message'],
  Grey: styles['wrapper__background--grey-message'],
  Success: styles['wrapper__background--success-message'],
  Warning: styles['wrapper__background--warning-message'],
  Error: styles['wrapper__background--error-message'],
  Blue: styles['wrapper__background--blue-message']
};
const toastIconType = {
  Dark: 'system-ui-check-default',
  Grey: 'system-ui-notifications-grey',
  Success: 'system-ui-check-circle-positive-xs',
  Warning: 'system-ui-warning-semantic-notice-80-xs',
  Error: 'system-ui-error-semantic-negative-80-xs',
  Blue: 'system-ui-check-hover'
};
const Toast = _ref => {
  let {
    toast
  } = _ref;
  const typeClass = toastTypeClassName[toast.type] || toastTypeClassName.Blue;
  const icon = toastIconType[toast.type] || toastIconType.Success;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.wrapper, typeClass)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, !!icon && /*#__PURE__*/React.createElement("div", {
    className: styles.content__icon
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon
  })), /*#__PURE__*/React.createElement("p", {
    className: styles.content__message
  }, toast.message), !!toast.action && /*#__PURE__*/React.createElement("button", {
    className: styles.content__action,
    onClick: () => toast.action?.onAction()
  }, toast.action?.name)), !!toast.onClose && /*#__PURE__*/React.createElement("button", {
    className: styles.wrapper__close,
    onClick: () => toast.onClose?.(),
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "system-ui-x-close-neutral-90-xs"
  })));
};
var Toast$1 = Toast;

export { Toast, Toast$1 as default };
//# sourceMappingURL=Toast.js.map
